import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent {
  /**
   * Image url
   */
  @Input() image: string;
  /**
   * Image size in pixels
   */
  @Input() size = 50;
}
